module.exports = __webpack_public_path__ + "static/media/PickUpIcon.0a2eb8f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/google-map/PickUpIcon.svg
// module id = 702
// module chunks = 0